"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureTogglesProvider = void 0;
var _react = _interopRequireDefault(require("react"));
var _featureTogglesContext = require("./featureTogglesContext");
var _jsxRuntime = require("react/jsx-runtime");
/** @deprecated Use the `FeatureTogglesProviderProps` interface from the `@ori/feature-toggles` library */

/** @deprecated Use the `FeatureTogglesProvider` component from the `@ori/feature-toggles` library */
const FeatureTogglesProvider = exports.FeatureTogglesProvider = /*#__PURE__*/_react.default.memo(({
  toggles,
  children
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_featureTogglesContext.featureTogglesContext.Provider, {
  value: toggles,
  children: children
}));
